module.exports = __webpack_public_path__ + "13e061a91df9d243cd799a7632358013.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/google-play-button.png
// module id = 2859
// module chunks = 0